import getAuthonticatedJSON from "../../common/utils/functions/getAuthonticatedJSON";
import postAuthonticatedJSON from "../../common/utils/functions/postAuthonticatedJSON";
import { config } from "../../config/config";

export const FETCH_SCALER_CHART_DATA = 'FETCH_SCALER_CHART_DATA';
export const FETCH_DROPDOWN_TREE_CASE = 'FETCH_DROPDOWN_TREE_CASE';
export const FETCH_TAGS = 'FETCH_TAGS';
export const FETCH_DATA = "FETCH_DATA";





export function loadScalerData(url) {
	return dispatch => {
        return getAuthonticatedJSON(url).then(response =>{
            dispatch(setScalerData(response));
        })
	};
}

export function setScalerData(data) {
	return {
		type: FETCH_SCALER_CHART_DATA,
		scalerData: data,
	};
}


export function loadTreeCase(url) {
	return dispatch => {
        return getAuthonticatedJSON(url).then(response =>{
            dispatch(setTreeCase(response));
        })
	};
}

export function setTreeCase(data) {
	return {
		type: FETCH_DROPDOWN_TREE_CASE,
		treeCase: data,
	};
}

export function loadTags(url) {
	return dispatch => {
        return getAuthonticatedJSON(url).then(response =>{
            dispatch(setTags(Object.values(response)));
        })
	};
}

export function setTags(data) {
	return {
		type: FETCH_TAGS,
		tags: data,
	};
}


export function outlookPaginationServer(action ='todo', start = 0, limit = 10, filter='', sort='',dir='',cat_uid='',pro_uid='',search = '',dateFrom='',dateTo = '',newerThan ='' , current=1) {
	return dispatch => {
		let URL = "";
		let token = localStorage.getItem('access_token');
		let request = {
			action: action,
			start: start,
			limit: limit,
			filter: filter,
			sort: sort,
			dir: 'DESC',
			cat_uid: cat_uid,
			pro_uid: pro_uid,
			search: search,
			dateFrom: dateFrom,
			dateTo: dateTo,
			newerThan: newerThan,
		};
		dispatch({
			type: FETCH_DATA,
			data: [],
			url: '',
			loading: true,
			pagination: {
				total: null,
				limit: null,
				current: null
			}
		})
		return postAuthonticatedJSON(config.apiServer + 'cases/new-inbox', request)
			.then(res => {
				dispatch({
					type: FETCH_DATA,
					data: res.data,
					
					loading: false,
					pagination: {
						total: res.total,
						limit: Number(res.limit),
						current: current,
						filter: res.search
					}
        })
			});
	}
}